import { useCallback, type FC } from "react";
import { useFormContext } from "react-hook-form";
import type { UUID } from "../../../../../utils/uuid";
import type { MomentFormMoment } from "../../../../moment/types/moment-form-moment";
import { usePolls } from "../../utils/use-polls";
import { PollPlugin } from "./poll-plugin";

export const PollPluginMomentFormWrapper: FC = () => {
  const polls_enabled = usePolls();

  const { setValue } = useFormContext<Pick<MomentFormMoment, "poll_ids">>();

  const setPollIds = useCallback((poll_ids: UUID[]) => setValue("poll_ids", poll_ids), [setValue]);

  if (!polls_enabled) return null;

  return <PollPlugin setPollIds={setPollIds} />;
};
